import { LegendOptions, Options, TooltipOptions, XAxisOptions } from 'highcharts';

export const defaultOptions: Options = {
  chart: {
    type: 'bar',
    animation: false,
    marginRight: 48,
  },
  credits: {
    enabled: false,
  },
  legend: {
    verticalAlign: 'top',
  },
  title: {
    text: undefined,
  },
};

export const chartContainerStyle = {
  width: '100%',
  height: '100%',
};

export const labelStyles = {
  fontSize: '12px',
  color: '#6f7582',
  fontWeight: 'normal',
  fontFamily: 'Lato',
};

export const legendOptions: LegendOptions = {
  align: 'center',
  verticalAlign: 'bottom',
  symbolHeight: undefined, // enables circle symbol
  symbolWidth: undefined, // enables circle symbol
  symbolRadius: undefined, // enables circle symbol,
  itemStyle: labelStyles,
  itemHoverStyle: {
    color: '#414752',
  },
  useHTML: true,
};

export const tooltipOptions: TooltipOptions = {
  shape: 'square',
  nullFormat: 'N/A',
  useHTML: true,
  backgroundColor: '#fff',
  shared: true,
  padding: 5,
  borderWidth: 0,
  shadow: false,
  borderRadius: 3,
  followPointer: false,
  style: {
    ...labelStyles,
    width: 300,
  },
};

export const xAxisOptions: XAxisOptions = {
  type: 'category',
  labels: {
    step: 1,
    useHTML: true,
    align: 'center',
  },
  crosshair: {
    dashStyle: 'Dash',
    width: 1,
    color: '#6f7582',
  },
  tickLength: 0,
  lineColor: '#bbc0c9',
};
